<template>
    <div id="loginPopup" class="loginMain" @click.self="removeDialog">

        <div ref="errorPrompt" class="errorPrompt">{{errorPromptContent}}</div>

        <div
            class="frame"
        >
            <input
                class="field"
                placeholder="手机号码"
                v-model="mobile"
            />

            <div class="verifyImg" v-show="false">
                <input
                    class="field"
                    style="width: calc(100% - 100px);"
                    placeholder="图形验证码"
                    v-model="verifyImg"
                />
                <div style="width: 8px;" />
                <div @click="changeVerifyImg" ref="verifyImgWrapper" style="width:100px;height:50px;position:relative;">
                    <img style="position:absolute;top:0;left:0;width: 100%;height: 100%;" src="https://shop.ziubao.com/user/getShearCaptcha.do" />
                </div>
            </div>

            <input
                class="field"
                placeholder="验证码"
                v-model="verifyCode"
            />
            <div class="verifyCode">
                <van-button
                    v-if="showFetchVerifyCode"
                    size="small"
                    plain
                    @click="fetchMobileVerifyCode('zlkc_invoice')"
                    >获取验证码</van-button
                >
                <div v-else class="showFetchVerifyCodeCountDownSecond">{{ showFetchVerifyCodeCountDownSecond }}s后可重新获取验证码</div>
            </div>

            <div class="privacyPrompt">
                <div
                    v-if="ifAgreeContract"
                    class="checkBoxActive"
                    @click="ifAgreeContract = !ifAgreeContract"
                >
                    <div class="content" />
                </div>
                <div
                    v-else
                    class="checkBoxNegative"
                    @click="ifAgreeContract = !ifAgreeContract"
                >
                    
                </div>
                <div class="privacyTitle">
                    我已阅读并同意自游宝<a
                        href="https://invoice.ziubao.com/main/static/pdf/web/viewer.html?file=https%3a%2f%2fzyb.ziubao.com%2fccbUnionUserService.pdf"
                        class="contract"
                        >《联合会员协议》</a
                    ><a
                        href="https://invoice.ziubao.com/main/static/pdf/web/viewer.html?file=https%3a%2f%2fzyb.ziubao.com%2fziubao_service.pdf"
                        class="contract"
                        >《用户协议》</a
                    >和<a
                        href="https://invoice.ziubao.com/main/static/pdf/web/viewer.html?file=https%3a%2f%2fzyb.ziubao.com%2fziubao_privacy.pdf"
                        class="contract"
                        >《隐私协议》</a
                    >
                </div>
            </div>

            <van-button
                type="primary"
                size="small"
                class="submit"
                @click="mobileLogin"
                >登录</van-button
            >
            <div style="height: 10px"></div>
            <van-button
                type="warning"
                size="small"
                class="submit"
                @click="removeDialog"
                >取消</van-button
            >
        </div>
    </div>
</template>

<script>
import { getMobile, saveMobile } from '#/storage/mobile'

//
import store from '@/store'
import router from '@/router';

/**
 * mobile
 */
const loginLastestTryTimeKey = "yingqiyu_ziubao_shop_login_lastest_try_time";

export const saveLoginLastestTryTime = time => {
    localStorage.setItem(loginLastestTryTimeKey, time);
}

export const getLoginLastestTryTime = () => {
    return localStorage.getItem(loginLastestTryTimeKey) || 0;
}

export default {
    name: 'Login',

    data() {
        return {
            mobile: getMobile(),
            verifyCode: '',

            ifAgreeContract: false,

            ifShowErrorPrompt: false,
            errorPromptContent: "",

            loginLastestTryTime: getLoginLastestTryTime(),
            showFetchVerifyCode: true,
            showFetchVerifyCodeCountDownSecond: 0,
            showFetchVerifyCodeCountDownSecondInterval: null,

            verifyImg: null,
        }
    },

    props: {
        fromUrl: {
            type: String,
        },
    },

    created()
    {
        this.createFetchVerifyCodeCountDown();
    },

    beforeDestroy()
    {
        if(this.showFetchVerifyCodeCountDownSecondInterval)
        {
            clearInterval(this.showFetchVerifyCodeCountDownSecondInterval);
        }
    },

    methods: {
        registerUser()
        {
            this.axios.ccbUrl.get("/registerUserToCCB?platform=wechat");
        },

        changeVerifyImg()
        {
            this.$refs.verifyImgWrapper.innerHTML = '';
            
            //
            const imgEle = document.createElement("img")
            imgEle.src = "https://shop.ziubao.com/user/getShearCaptcha.do";
            imgEle.style="position:absolute;top:0;left:0;width: 100%;height: 100%;"
            this.$refs.verifyImgWrapper.appendChild(imgEle);
        },

        createFetchVerifyCodeCountDown()
        {
            const nowTime = Date.now();
            if(parseInt((nowTime - this.loginLastestTryTime) / 1000) < 60)
            {
                //
                this.showFetchVerifyCode = false;
                this.showFetchVerifyCodeCountDownSecond = 60 - parseInt((nowTime - this.loginLastestTryTime) / 1000);
                //
                this.showFetchVerifyCodeCountDownSecondInterval = setInterval(() => {
                    this.showFetchVerifyCodeCountDownSecond -= 1;
                    if(this.showFetchVerifyCodeCountDownSecond <= 0)
                    {
                        // clear interval
                        clearInterval(this.showFetchVerifyCodeCountDownSecondInterval);
                        //
                        this.showFetchVerifyCode = true;
                    }
                }, 1000);
            }
            else
            {
                this.showFetchVerifyCode = true;
            }
        },

        showErrorPrompt(content)
        {
            if(this.ifShowErrorPrompt)
            {
                return;
            }

            this.ifShowErrorPrompt = true;
            this.errorPromptContent = content;

            this.$nextTick(() => {
                this.$refs.errorPrompt.style.backgroundColor = "#00000088";
                this.$refs.errorPrompt.style.color = "#ffffffff";

                setTimeout(() => {
                    

                    this.$refs.errorPrompt.style.backgroundColor = "#00000000";
                    this.$refs.errorPrompt.style.color = "#ffffff00";

                    setTimeout(() => {
                       this.ifShowErrorPrompt = false; 
                    }, 500);
                }, 1000);

            })
        },

        fetchMobileVerifyCode(type) {
            if(false)
            {
                if(!this.verifyImg || this.verifyImg.length == 0)
                {
                    return this.showErrorPrompt("请输入正确的图形验证码");
                }
            }

            this.axios.shop
                .get('/user/doUserValidate.do', {
                    userName: this.mobile,
                    // code: this.verifyImg,
                    connect_redirect: 1,
                })
                .then(({ msg, data }) => {
                    if (data === true) {
                        //
                        this.loginLastestTryTime = Date.now();
                        saveLoginLastestTryTime(this.loginLastestTryTime);
                        this.createFetchVerifyCodeCountDown();

                        //
                        return this.showErrorPrompt('验证码已发送')
                    }

                    //
                    this.showErrorPrompt(msg)
                })
                .catch((e) => {
                    this.showErrorPrompt(`获取验证码失败, ${e.toString()}`)
                })
        },

        mobileLogin() {
            // check phone
            if (!this.mobile || this.mobile.length == 0) {
                return this.showErrorPrompt('手机号码不能为空')
            }
            if (!this.verifyCode || this.verifyCode.length == 0) {
                return this.showErrorPrompt('验证码不能为空')
            }

            //
            if (!this.ifAgreeContract) {
                return this.showErrorPrompt('请仔细阅读并同意《联合会员协议》《用户协议》和《隐私协议》')
            }

            //
            saveMobile(this.mobile)

            //
            this.axios.shop
                .get('/user/doLogin.do', {
                    userName: this.mobile,
                    code: this.verifyCode,
                })
                .then(({ msg, statusCode, data }) => {
                    if (data && data.result == 1) {
                        //
                        store.dispatch('auth/getUserInfo')

                        //
                        this.$emit('loginSuccess')
                        
                        //
                        this.registerUser();
                        
                        //
                        if(this.fromUrl && this.fromUrl.length > 0)
                        {
                            return window.location.replace(decodeURIComponent(this.fromUrl));
                        }

                        //
                        if(this.remove)
                        {
                            return this.remove()
                        }
                    } else if (statusCode == '500') {
                        return this.showErrorPrompt(msg)
                    }

                    //
                    this.showErrorPrompt('登录失败, 用户名或者密码错误')
                })
                .catch((e) => {
                    this.showErrorPrompt(`登录失败, ${e.toString()}`)
                })
        },

        removeDialog() {
            if(this.remove) {
                this.remove()
            }
        },
    },
}
</script>

<style lang="scss" scoped>
$productSpecificationListFrameWidth: 80vw;
$productSpecificationListFrameHeight: 85vh;

//
.loginMain {
    z-index: 9999;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    background-color: $neutralMaskColor;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: $fontSizeContent;
}

.errorPrompt {
    position: absolute;
    width: 50vw;
    box-sizing: border-box;
    z-index: 1;
    transition: all 0.5s linear;
    padding: $padding;
    border-radius: $borderRadius;
    text-align: center;
}

.frame {
    display: flex;
    flex-direction: column;
    width: $productSpecificationListFrameWidth;
    background: #ffffff;
    border-radius: $borderRadius;
    box-sizing: border-box;
    padding: $padding;
}

//
.field {
    width: 100%;
    margin: $margin 0em;
    text-align: center;
}

.verifyImg
{
    width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
}

.verifyCode {
    width: 100%;
    text-align: right;
    box-sizing: border-box;
}

.showFetchVerifyCodeCountDownSecond
{
    box-sizing: border-box;
    padding: $padding;
}

.privacyPrompt {
    width: 100%;
    margin: 1em 0em;
    display: flex;
    align-items: center;
}

.checkBoxNegative {
    width: 1.6em;
    height: 1.6em;
    margin-right: $margin;
    border-radius: 50%;
    box-shadow: inset 0em 0em 0.25em #888888;
}

.checkBoxActive {
    @extend .checkBoxNegative;

    .content {
        width: 1.4em;
        height: 1.4em;
        margin-left: 0.1em;
        margin-top: 0.1em;
        border-radius: 50%;
        background-color: #428ffc;
    }
}

.privacyTitle {
    display: inline-block;
    width: calc(100% - 1.5em);
}

.submit {
    width: 100%;
    box-sizing: border-box;
}

.contract {
    font-weight: 800;
    color: $neutralFontWeakColor;
}
</style>